import * as React from "react";
import type { SVGProps } from "react";
const SvgIconConstructionYear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M410.11 476.67H101.97V243.04h12.77V463.9h282.59V300.91h12.78z"
    />
    <path
      fill="#242323"
      d="M458.4 256.28 252.5 53.42 53.75 256.2l-9.12-8.94L252.35 35.33l215.02 211.85zM121.66 150.56h-12.78V91.58h54.93v12.78h-42.15zM305.54 454.5h-12.77v-46.41h90.76v12.78h-77.99zM201.7 454.5h-12.77v-46.41h90.75v12.78H201.7zM243.89 395.01h-12.78V348.6h90.76v12.78h-77.98zM346.65 395.01h-12.78V348.6h49.66v12.78h-36.88z"
    />
  </svg>
);
export default SvgIconConstructionYear;
